import React, { useEffect, useState } from "react";
import { Container, Row, Col, Table, Badge } from "react-bootstrap";
import { fetchCodePromoStats } from "./DataService";
import ClickBack from "../../components/buttons/ClickBack";

function StatsScreen() {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCodePromoStats()
      .then((data) => setStats(data.data || []))
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }, []);

  const statusBadge = (status) => {
    const map = {
      active: ["success", "Actif"],
      expired: ["danger", "Expiré"],
      archived: ["secondary", "Archivé"],
    };
    const [bg, label] = map[status] || ["secondary", status];
    return <Badge bg={bg}>{label}</Badge>;
  };

  const formatReduction = (cp) => {
    if (parseFloat(cp.reduction) > 0) return `-${cp.reduction} €`;
    if (parseFloat(cp.reduction_percent) > 0) return `-${cp.reduction_percent}%`;
    return "—";
  };

  return (
    <Container>
      <p className="h6">Accueil / Codes promo / Infos</p>
      <Row className="pt-4 pb-2 align-items-center">
        <Col className="d-flex align-items-center">
          <ClickBack />
          <h1 className="p-1">Codes promo — Infos</h1>
        </Col>
      </Row>

      {loading ? (
        <p className="lead">Chargement...</p>
      ) : stats.length === 0 ? (
        <p className="text-muted">Aucun code promo trouvé.</p>
      ) : (
        <Table striped bordered hover responsive className="mt-3">
          <thead className="table-dark">
            <tr>
              <th>Code</th>
              <th>Titre</th>
              <th>Statut</th>
              <th>Réduction</th>
              <th className="text-center">Nb commandes</th>
              <th className="text-end">CA HT</th>
              <th className="text-end">CA TTC</th>
            </tr>
          </thead>
          <tbody>
            {stats.map((cp) => (
              <tr key={cp.id} className={cp.nb_commandes === 0 ? "text-muted" : ""}>
                <td><strong>{cp.code}</strong></td>
                <td>{cp.title || "—"}</td>
                <td>{statusBadge(cp.status)}</td>
                <td>{formatReduction(cp)}</td>
                <td className="text-center">
                  {cp.nb_commandes > 0 ? (
                    <Badge bg="primary">{cp.nb_commandes}</Badge>
                  ) : (
                    <span className="text-muted">0</span>
                  )}
                </td>
                <td className="text-end">{cp.ca_ht.toFixed(2)} €</td>
                <td className="text-end">{cp.ca_ttc.toFixed(2)} €</td>
              </tr>
            ))}
          </tbody>
          <tfoot className="table-secondary fw-bold">
            <tr>
              <td colSpan={4}>Total</td>
              <td className="text-center">
                {stats.reduce((sum, cp) => sum + cp.nb_commandes, 0)}
              </td>
              <td className="text-end">
                {stats.reduce((sum, cp) => sum + cp.ca_ht, 0).toFixed(2)} €
              </td>
              <td className="text-end">
                {stats.reduce((sum, cp) => sum + cp.ca_ttc, 0).toFixed(2)} €
              </td>
            </tr>
          </tfoot>
        </Table>
      )}
    </Container>
  );
}

export default StatsScreen;
